import React, { useMemo, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import { useTranslation } from "react-i18next";
import Colors from "../../../../constants/colors";
import RadioSelectedIcon from "../../../../../../../assets/images/RadioSelectButton.svg";
import FlatListDataComponent from "../../common/FlatListDataComponent";
import type { CountrySubdivision } from "../models/countrySubdivision";
import { useJourneyStore } from "../store/sendmoneyJourneyStore";
import { useWorkflowNavigation } from "../hooks/useWorkflowNavigation";

export function StateScreen() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [selectedState, setSelectedState] = useState<string | null>(null);
  const destinationCountry = useJourneyStore(
    (state) => state.journeyData.destinationCountry
  );
  const updateJourneyData = useJourneyStore((state) => state.updateJourneyData);
  const { goNext } = useWorkflowNavigation();

  const states = destinationCountry?.subdivisions ?? [];

  const filteredStates = useMemo(() => {
    const q = search.toLowerCase();
    return states.filter((s) =>
      (s.name || "").toLowerCase().includes(q)
    );
  }, [states, search]);

  const onSelectState = (item: CountrySubdivision) => {
    setSelectedState(item.name);
    updateJourneyData({ destinationState: item });
    setTimeout(() => {
      goNext();
    }, 200);
  };

  return (
    <View style={styles.container} testID="state-screen">
      <FlatListDataComponent
        title={t("STATE_STEP_TITLE")}
        subTitle={t("CHOOSE_WHAT_STATE_YOU_ARE_SENDING_TO")}
        searchPlaceHolder={t("COUNTRY_STEP_SEARCH_PLACEHOLDER")}
        searchValue={search}
        onSearchChangeText={setSearch}
        filteredData={filteredStates}
        searchTestID="sendMoneyStateSearchInput"
        flatListTestID="sendMoneyStateList"
        renderItem={(item: CountrySubdivision) => (
          <TouchableOpacity
            testID="sendMoneyStateSelected"
            style={styles.stateRow}
            onPress={() => onSelectState(item)}
          >
            <Text style={styles.stateName}>
              {item.name} ({item.code})
            </Text>
            <View style={styles.radioButton}>
              {selectedState === item.name && (
                <RadioSelectedIcon width={20} height={20} />
              )}
            </View>
          </TouchableOpacity>
        )}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    backgroundColor: Colors.white,
  },
  stateRow: {
    backgroundColor: Colors.white,
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    borderBottomWidth: 0,
    justifyContent: "space-between",
  },
  stateName: {
    fontSize: 16,
    fontWeight: "400",
    fontFamily: "Rubik",
    lineHeight: 20,
    color: Colors.titleTextColor,
  },
  radioButton: {
    width: 20,
    height: 20,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.radioButtonFilled,
  },
});
